import { PropsWithChildren } from 'react';
import { EnvironmentBanner } from '../components/common/EnvironmentBanner/EnvironmentBanner';
import { Navbar } from '../components/common/Navbar/Navbar';
import { Footer } from '../components/common/Footer/Footer';
import { Announcements } from '../components/common/Announcements/Announcements.connect';
import { useAuth } from 'react-oidc-context';
import './Layout.scss';

export const FullLayout = ({ children }: PropsWithChildren) => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      <EnvironmentBanner />
      <div className="app__content-box">
        <Navbar />
        {isAuthenticated && <Announcements />}
        {children}
      </div>
      <Footer />
    </>
  );
};
